import React, { useState, useEffect, useContext } from "react";
import { Link, Redirect } from "react-router-dom";
import Header from "../../../User/Header";
import { Table, Modal, notification, Switch, Icon } from "antd";
import DrawerFotos from "./Drawer/DrawerFotos";
import axios from "axios";
import { ArrowCircleLeft } from "iconsax-react";
import { GlobalContext } from "../../../app/providers/GlobalState";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Fotos = () => {
    const [ativo, setAtivo] = useState(true);
    const [galerias, setGalerias] = useState([]);
    const [galeriaId, setGaleriaId] = useState(0);
    const [visible, setVisible] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [loading, setLoading] = useState(false);

    const globalContext = useContext(GlobalContext);

    const listar = () => {
        setLoading(true);
        axios({
            method: "get",
            url: "/api/fotos-recentes/listar",
            params: {
                ativo
            }
        })
            .then(response => {
                const lista = response.data.map(galeria => {
                    return {
                        key: galeria.id,
                        id: galeria.id,
                        titulo: galeria.titulo,
                        estabelecimentos: galeria.estabelecimentos.join(", "),
                        opcoes: montarMenu(galeria.id)
                    };
                });

                setGalerias(lista);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    };

    const montarMenu = id => {
        const divStyle = { display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end" };

        if (ativo)
            return (
                <div style={divStyle}>
                    <Link
                        to="#"
                        className="botao-icon-inativar"
                        title="Inativar"
                        onClick={event => {
                            event.stopPropagation();
                            ativar(id);
                        }}
                    >
                        <Icon type="close" />
                    </Link>
                </div>
            );

        return (
            <div style={divStyle}>
                <Link
                    to="#"
                    className="botao-icon-ativar"
                    title="Ativar"
                    onClick={event => {
                        event.stopPropagation();
                        ativar(id);
                    }}
                >
                    <Icon type="check" />
                </Link>
                <Link
                    to="#"
                    className="botao-icon-excluir"
                    title="Excluir"
                    onClick={event => {
                        event.stopPropagation();
                        excluir(id);
                    }}
                >
                    <Icon type="delete" />
                </Link>
            </div>
        );
    };

    const excluir = id => {
        confirm({
            title: "Pretende excluir esta galeria?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "patch",
                    url: "/api/fotos-recentes/excluido",
                    params: {
                        id
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Galeria excluida!");
                        listar();
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir a galeria!");
                    });
            }
        });
    };

    const ativar = id => {
        confirm({
            title: ativo ? "Pretende inativar esta galeria?" : "Pretende ativar esta galeria?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "patch",
                    url: "/api/fotos-recentes/toggle-ativo",
                    params: {
                        id
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", ativo ? "Galeria inativada!" : "Galeria ativada!");
                        listar();
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível inativar a galeria!" : "Não foi possível ativar a galeria!"
                        );
                    });
            }
        });
    };

    const onRowClick = id => {
        setVisible(true);
        setGaleriaId(id);
    };

    useEffect(() => {
        listar(true);
    }, [ativo]);

    const columns = [
        {
            title: "Título",
            dataIndex: "titulo"
        },
        {
            title: "Estabelecimentos",
            dataIndex: "estabelecimentos"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    const columnsMobile = [
        {
            title: "Título",
            dataIndex: "titulo"
        },
        {
            title: "Estabelecimentos",
            dataIndex: "estabelecimentos"
        },
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Galerias de fotos" />
            <div className="administracao-empresa">
                <div className="container container-body">
                    <div style={{ minHeight: 600, background: "white" }}>
                        <div className="bloco-minha-conta">
                            <div className="bloco-gestor-paginas">
                                <div className="noticias container-body">
                                    <div className="controlos" style={{ display: "flex", justifyContent: "space-between" }}>
                                        <button
                                            className="botao-principal botao-principal-redondo"
                                            title="Adicionar"
                                            style={{ marginTop: 0 }}
                                            onClick={() => {
                                                setVisible(true);
                                                setGaleriaId(0);
                                            }}
                                            disabled={!ativo}
                                        >
                                            +
                                        </button>
                                        <div className="filtro">
                                            <Switch
                                                checkedChildren="Ativos"
                                                unCheckedChildren="Inativos"
                                                defaultChecked
                                                onChange={ativo => setAtivo(ativo)}
                                            />
                                            <Link
                                                className="botao-voltar2"
                                                to="/utilizador"
                                                onClick={() => {
                                                    globalContext.atualizarState({
                                                        mostrarOptPaginasPublicas: true
                                                    });
                                                }}
                                            >
                                                <ArrowCircleLeft size={34} />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="bloco-tabela">
                                        <Table
                                            id="tabela_categorias"
                                            className="tabela-paginas-desktop"
                                            loading={{
                                                spinning: loading,
                                                indicator: (
                                                    <div className="loading-data-table">
                                                        <div className="loading" />
                                                    </div>
                                                )
                                            }}
                                            columns={columns}
                                            dataSource={galerias}
                                            pagination={false}
                                            rowClassName="clickeble-row"
                                            onRow={(record, index) => {
                                                return {
                                                    onClick: () => onRowClick(record.id)
                                                };
                                            }}
                                            locale={{ emptyText: "Não existem dados!" }}
                                        />
                                        <Table
                                            id="tabela_categorias"
                                            className="tabela-paginas-mobile"
                                            loading={{
                                                spinning: loading,
                                                indicator: (
                                                    <div className="loading-data-table">
                                                        <div className="loading" />
                                                    </div>
                                                )
                                            }}
                                            columns={columnsMobile}
                                            dataSource={galerias}
                                            pagination={false}
                                            rowClassName="clickeble-row"
                                            onRow={(record, index) => {
                                                return {
                                                    onClick: () => onRowClick(record.id)
                                                };
                                            }}
                                            locale={{ emptyText: "Não existem dados!" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DrawerFotos
                ativo={ativo}
                id={galeriaId}
                visible={visible}
                onClose={() => setVisible(false)}
                atualizar={() => {
                    setVisible(false);
                    listar();
                }}
            />
        </>
    );
};

export default Fotos;
